/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import user from "../../http/requests/user";
import Helpers from "../../utils/helpers";

export default {
	// addItem({ commit }, item) {
	//   return new Promise((resolve, reject) => {
	//     axios.post("/api/data-list/products/", {item: item})
	//       .then((response) => {
	//         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
	//         resolve(response)
	//       })
	//       .catch((error) => { reject(error) })
	//   })
	// },

	exportData({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				user.exportData(payload)
					.then(response => {
						resolve(response);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchPond]", error);
		}
	},
	fetchUsers({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				user.getListUsers(payload)
					.then(response => {
						console.log("[fetchUsers]", response.data.data);

						// let finalUsers = Helpers.baseLocalSort(response.data.data.users, "fullname");
						commit("SET_USERS", response.data.data.users);
						commit("SET_TOTAL_USERS", response.data.data.total);
						resolve(response.data.data);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchUsers]", error);
		}
	},
	fetchUsers2({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				user.getListUsers2(payload)
					.then(response => {
						console.log("[fetchUsers2]", response.data.data);

						// let finalUsers = Helpers.baseLocalSort(response.data.data.users, "fullname");
						commit("SET_USERS2", response.data.data.users);
						commit("SET_TOTAL_USERS2", response.data.data.total);
						resolve(response.data.data);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchUsers2]", error);
		}
	},
	fetchUsers3({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				user.getListUsers3(payload)
					.then(response => {
						console.log("[fetchUsers3]", response.data.data);

						// let finalUsers = Helpers.baseLocalSort(response.data.data.users, "fullname");
						commit("SET_USERS3", response.data.data.users);
						commit("SET_TOTAL_USERS3", response.data.data.total);
						resolve(response.data.data);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchUsers2]", error);
		}
	},
	removeRecord({ commit }, userId) {
		return new Promise((resolve, reject) => {
			user.deleteUser(userId)
				.then(response => {
					commit("REMOVE_USER", userId);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	addUser({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				user.createUser(payload)
					.then(response => {
						console.log("[ADD_USER] throw", response);
						if (response.data && response.data.error_code && response.data.error_code !== 0) {
							throw response.data.error_message;
						} else {
							console.log("[ADD_USER]", response.data.user);
							commit("ADD_USER", response.data.user);
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[addUser]", error);
		}
	},
	updateUser({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				user.updateUser(payload.id, payload.data)
					.then(response => {
						if (response.data && response.data.error_code !== 0) {
							console.log("[UPDATE_USER] throw");
							throw response.data.error_message;
						} else {
							console.log("[UPDATE_USER]", response.data.data.user);
							commit("UPDATE_USER", response.data);
							resolve(response);
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[updateUser]", error);
		}
	}
};
